export default __webpack_public_path__ + "static/media/zukunf_lauft_background_s2.d8e42cbe.jpg";